import { useEffect } from 'react';
import { usePlatformStore } from '@edgerunner/shared';
import { useAuthStore } from '../stores/authStore';

export type AuthGateStatus = 'loading' | 'unauthenticated' | 'authenticated' | 'bypassed';

export function useAuthGate(): AuthGateStatus {
  const isDesktop = usePlatformStore((s) => s.isDesktop);
  const deploymentMode = usePlatformStore((s) => s.deploymentMode);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const isSessionChecked = useAuthStore((s) => s.isSessionChecked);
  const checkSession = useAuthStore((s) => s.checkSession);

  // Trigger session check once we know we're in web deployment mode
  // (deploymentMode is resolved by waitForBackend once backend responds)
  useEffect(() => {
    if (deploymentMode === 'web' && !isSessionChecked) {
      checkSession();
    }
  }, [deploymentMode, isSessionChecked, checkSession]);

  // Electron or desktop deployment: skip auth entirely
  if (isDesktop() || deploymentMode === 'desktop') {
    return 'bypassed';
  }

  // Waiting for backend to respond with deployment mode, or session check
  if (deploymentMode === null || !isSessionChecked) {
    return 'loading';
  }

  return isAuthenticated ? 'authenticated' : 'unauthenticated';
}
